import { useMemo } from 'react';
export function useRicosTheme(customTheme) {
  return useMemo(() => ({
    palette: {
      type: 'rgb',
      bgColor: 'var(--wix-forms-formInputBackgroundColor)',
      textColor: 'var(--wix-forms-formParagraphColor)',
      actionColor: 'var(--wix-forms-formLinkColor)'
    },
    ...customTheme
  }), [customTheme]);
}
export const getHeaderAndParagraphCustomStylesWUT = () => {
  return {
    h1: {
      fontSize: 'var(--wix-forms-formHeaderOneFont-size, 28px)',
      fontFamily: 'var(--wix-forms-formHeaderOneFont-family)',
      color: 'rgb(var(--wix-forms-formHeaderOneColor, 0,0,0))'
    },
    h2: {
      fontSize: 'var(--wix-forms-formHeaderTwoFont-size, 20px)',
      fontFamily: 'var(--wix-forms-formHeaderTwoFont-family)',
      color: 'rgb(var(--wix-forms-formHeaderTwoColor, 0,0,0))'
    },
    p: {
      fontSize: 'var(--wix-forms-formParagraphFont-size, 16px)',
      fontFamily: 'var(--wix-forms-formParagraphFont-family)',
      color: 'rgb(var(--wix-forms-formParagraphColor, 0,0,0))'
    }
  };
};
export const getRicosPaletteWDS = () => {
  const textColor = '#000624';
  const actionColor = '#116DFF';
  return {
    textColor,
    actionColor
  };
};
export const getHeaderAndParagraphCustomStylesWDS = () => {
  const fallback = `Madefor,"Helvetica Neue",Helvetica,Arial,"meiryo","hiragino kaku gothic pro", sans-serif`;
  const headingFontFamily = `var(--wds-font-family-display, var(--wds-font-family-default, var(--wsr-font-family, ${fallback})))`;
  const bodyFontFamily = `var(--wds-font-family-default, var(--wsr-font-family, ${fallback}))`;
  const color = 'var(--wds-color-text-standard-primary, var(--wsr-color-D10, #162D3D))';
  return {
    h1: {
      fontSize: `var(--wds-font-size-heading-1, var(--wsr-heading-font-size-xl, 28px))`,
      fontFamily: headingFontFamily,
      color
    },
    h2: {
      fontSize: `var(--wds-font-size-heading-2, var(--wsr-heading-font-size-l, 21px))`,
      fontFamily: headingFontFamily,
      color
    },
    p: {
      fontSize: `var(--wds-font-size-body-medium, var(--wsr-text-font-size-medium, 16px))`,
      fontFamily: bodyFontFamily,
      color
    }
  };
};
//# sourceMappingURL=ricos-theme-utils.js.map